
import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReportTab } from "./ReportTabs";

interface ReportTabsListProps {
  tabs: ReportTab[];
}

const ReportTabsList: React.FC<ReportTabsListProps> = ({ tabs }) => {
  return (
    <div className="overflow-x-auto pb-2">
      <TabsList className="h-auto p-1 bg-muted/80 backdrop-blur-sm">
        {tabs.map((tab) => (
          <TabsTrigger 
            key={tab.id} 
            value={tab.id} 
            className="flex items-center gap-2 px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-secondary data-[state=active]:text-primary data-[state=active]:shadow-sm data-[state=active]:font-medium transition-all"
          >
            {tab.icon}
            <span>{tab.label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  );
};

export default ReportTabsList;
